<template>
  <div class="auth-signup">
    <div>
      <div class="heading-4 black--text">
        Sign up. <br />
        Yield smarter with an Unagii Account.
      </div>
      <div class="mt-10">
        <div class="d-flex align-center">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Instant access to consolidated portfolio across products anywhere
          </div>
        </div>
        <div class="d-flex align-center mt-3">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Stay updated with latest news and exclusive notifications
          </div>
        </div>
        <div class="d-flex align-center mt-3">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Potential to earn campaign bonuses
          </div>
        </div>
      </div>
      <ValidationObserver ref="observer">
        <form @submit.prevent="submit">
          <div class="mt-8">
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                name="Email"
                rules="required|email"
              >
                <v-text-field
                  id="email"
                  outlined
                  single-line
                  class="c-input"
                  placeholder="Email address"
                  type="email"
                  required
                  v-model="payload.email"
                  hide-details="auto"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                name="Password"
                rules="required|min:8|max:64"
              >
                <v-text-field
                  autofocus
                  id="password"
                  v-model="payload.password"
                  :append-icon="showPwd ? 'far fa-eye' : 'far fa-eye-slash'"
                  :type="showPwd ? 'text' : 'password'"
                  @click:append="showPwd = !showPwd"
                  outlined
                  single-line
                  class="c-input mt-3"
                  placeholder="Password"
                  required
                  hide-details="auto"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <div class="mt-4">
            <div id="signupRecaptcha"></div>
          </div>
          <div class="error--text mt-4" v-if="signupState.codeSendingError">
            {{ signupState.codeSendingError.message }}
          </div>
          <div class="error--text mt-4" v-if="recaptchaError">
            {{ recaptchaError }}
          </div>
          <div class="mt-8">
            <input type="submit" class="d-none" />
            <c-btn
              @click="submit"
              :loading="signupState.codeSending"
              :disabled="!agreedCheckbox"
              class="width-100"
              >Sign Up</c-btn
            >
          </div>
        </form>
      </ValidationObserver>
      <div class="mt-5 text-6 gray--text text-center ml-3 mr-3">
        or
      </div>
      <div class="mt-5">
        <social-auth />
      </div>
      <div class="mt-5 text-6 darkgray--text text-center line-height-50">
        By signing up, you agree to Unagii’s
        <a
          href="https://www.unagii.com/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >Terms & Conditions</a
        >
        and
        <a
          href="https://www.unagii.com/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >Privacy Policy</a
        >, and will be subscribed to our mailing list.
      </div>
    </div>
    <div>
      <v-divider class="mt-10 mb-10"></v-divider>
      <continue-anonymously @showConnectWallet="$emit('showConnectWallet')" />
    </div>
    <div class="mt-10">
      <protect-statement />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SocialAuth from "../SocialAuth";
import ContinueAnonymously from "../ContinueAnonymously";
import ProtectStatement from "../ProtectStatement";
import { required, min, max, email } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import Config from "@/common/config";
import { getUserResponse } from "@/common/lib/recaptcha";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty.",
});

extend("min", {
  ...min,
  message: "Please enter 8 to 64 alphanumeric characters or symbols.",
});

extend("max", {
  ...max,
  message: "Please enter 8 to 64 alphanumeric characters or symbols.",
});

extend("email", {
  ...email,
  message: "Enter valid email address.",
});

export default {
  components: {
    SocialAuth,
    ContinueAnonymously,
    ProtectStatement,
    ValidationObserver,
    ValidationProvider,
  },
  props: ["email"],
  data: () => ({
    payload: {
      password: "",
      email: "",
      subscribed: true,
    },
    agreedCheckbox: true,
    showPwd: false,
    recaptchaError: "",
  }),
  computed: {
    ...mapGetters({
      signupState: "auth/signup",
    }),
  },
  methods: {
    async submit() {
      const isFormValid = await this.$refs.observer.validate();
      const recaptchaResponse = getUserResponse();
      if (!recaptchaResponse) {
        this.recaptchaError = "Your reCAPTCHA response is not valid.";
        return;
      }
      this.payload.token = recaptchaResponse;
      if (isFormValid) {
        this.$emit("submit", this.payload);
      }
    },
  },
  mounted() {
    this.payload.email = this.email;
    this.recaptchaError = "";
    if (window.grecaptcha && "function" === typeof window.grecaptcha.render) {
      window.grecaptcha.render("signupRecaptcha", {
        sitekey: Config.recaptchaSiteKey,
      });
    }
  },
};
</script>
